import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'flippedToNewInvestorDate',
    label: 'Flipped to New Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'markedUnsalableDate',
    label: 'Marked Unsalable Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteReturnRequestedDate',
    label: 'Note Return Requested Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unsalableResponsibleParty',
    label: 'Unsalable Responsible Party',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unsalableReason',
    label: 'Unsalable Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'purchaseDenialReason',
    label: 'Purchase Denial Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const flippedUnsalableForm = {
  name: FormNames.POST_CLOSING,
  label: 'Flipped / Unsalable',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
